import { Component, OnInit } from '@angular/core';
import { HttpQueriesService } from '../Services/http-queries.service';

@Component({
  selector: 'app-congres-virtuel-manager',
  templateUrl: './congres-virtuel-manager.component.html',
  styleUrls: ['./congres-virtuel-manager.component.scss']
})
export class CongresVirtuelManagerComponent implements OnInit {

  access_code = {original:'YnAjYjR3eTJXZ2FXd1RHRg==', entered:null}; //bp#b4wy2WgaWwTGF
  showPopupAccess = true;

  stands = null;
  temp_list:any = [];

  loading = true;
  error = false;
  server = null;

  standformdisplay = false;
  stand_form = {stand_name:null, stand_image:null, link_website:null, apropos:null, adresse:null, telephone:null, hall:null, main_video:null};
  stand_image_sizes = {1:{width:1920, height:869}, 2:{width:1435, height:776}};
  saving = false;

  constructor(private httpservice:HttpQueriesService) {}

  ngOnInit() {
    let code = localStorage.getItem('manager-code');
    this.checkManagerAccess(code);  
  }

  checkManagerAccess(code){
    if(code && btoa(code) == this.access_code.original){
      this.showPopupAccess = false;
      localStorage.setItem('manager-code', code);
      this.server = this.httpservice.getServer();
      this.getAllStands();
    }
  }

  checkAndAccess(){
    this.checkManagerAccess(this.access_code.entered);
  }

  getAllStands(){
    this.httpservice.getAllStands().subscribe(val=>{
      this.stands = val;
      this.temp_list = val;
      this.loading = false;

    }, error=>{
      this.loading = false;
      this.error = true;

    });
  }

  searchInStandList(input: string){
    (input != "") ? this.stands = this.stands.filter(v => v.stand_name.toLowerCase().indexOf(input.toLowerCase()) !== -1) 
                  : this.stands = this.temp_list;
  }

  showStandForm(){
    this.standformdisplay = true;
  }

  closeStandForm(){
    this.standformdisplay = false;
    this.stand_form = {stand_name:null, stand_image:null, link_website:null, apropos:null, adresse:null, telephone:null, hall:null, main_video:null};
  }

  onFileChange(fileInput: any) {
    const file = fileInput.target.files[0];
   
    const Img = new Image();
      Img.src = URL.createObjectURL(file);
  
      Img.onload = (e: any) => {
        if(this.stand_form.hall && e.path[0].width == this.stand_image_sizes[this.stand_form.hall].width 
          && e.path[0].height == this.stand_image_sizes[this.stand_form.hall].height){
          
            this.stand_form.stand_image = {file:file, name:file.name, file_size:file.size};

        }else{
          alert('L\'image doit etre ' + this.stand_image_sizes[this.stand_form.hall].width + ' x ' + this.stand_image_sizes[this.stand_form.hall].height + ' px');
        
        }
      }
    
    fileInput.srcElement.value = null;
  }

  saveStandData(){
    this.saving = true;
    this.httpservice.saveStandData(this.prepareFormData()).subscribe(v=>{
      this.saving = false;
      this.stands.unshift(v);
      this.closeStandForm();

    }, error=>{
      this.saving = false;
      alert('Une erreur s\'est occurée, veuillez réessayer.');

    })
  }

  prepareFormData(){
    let formData = new FormData();
    formData.append("stand_image", this.stand_form.stand_image.file);
    formData.append("form", JSON.stringify(this.stand_form));
    return formData;
  }

}
